import PayrollInvoices from './PayrollInvoices';

export default PayrollInvoices;
